import React from 'react';
import PropTypes from 'prop-types';
import styles from '../styles/Loader.module.css';

const Loader = ({ label, labelDirection = 'bottom' }) => {
  const directionClass = {
    top: styles.columnReverse,
    bottom: styles.column,
    left: styles.rowReverse,
    right: styles.row,
  }[labelDirection] || styles.column;

  return (
    <div className={`${styles.wrcLoader} ${directionClass}`}>
      <div className={styles.wrcLoaderSpinner}></div>
      <span className={styles.wrcLoaderLabel}>{label}</span>
    </div>
  );
};

Loader.propTypes = {
  label: PropTypes.string,
  labelDirection: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
};

export default Loader;
